import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHashtag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHashtag"><Path d="M8.5 3.5L6.5 20.5M17.5 3.5L15.5 20.5M3.5 7.5H20.5M20.5 16.5H3.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconHashtag;
